<template>
  <identify v-if="showIdentify" :title="null" :selected-features="featureSelection" />
  <div id="details-map" class="relative h-100 w-full rounded">
    <time-tool v-if="showTimeTool" />
    <map-button-container state-module="DetailsMap" />
  </div>
</template>

<script>
import MapButtonContainer from '@/components/map-components/buttons/MapButtonContainer'
import { computed, onMounted } from 'vue'
import { useStore } from 'vuex'
import '@/services/map-services/ol-map-extensions'
import Identify from '@/components/map-components/identify/Identify'
import TimeTool from '@/components/map-components/time-tool/TimeTool'

export default {
  name: 'PreviewMap',
  components: { TimeTool, Identify, MapButtonContainer },
  props: {
    layerId: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const store = useStore()

    onMounted(async () => {
      await store.dispatch('DetailsMap/init').then(() => {
        store.dispatch('DetailsMap/addLayer', props.layerId)
        // @ts-ignore
        store.state.DetailsMap.ol.map.AddOnClickSelection(store, store.state.DetailsMap.ol.selectionLayer)
      })
    })

    const showTimeTool = computed(() => {
      return store.state.TimeTool.active
    })

    const showIdentify = computed(() => {
      return store.state.Identify.active
    })

    const featureSelection = computed(() => {
      return store.state.Identify.data
    })

    return { showIdentify, featureSelection, showTimeTool }
  },
}
</script>

<style scoped>

</style>
